export const uk = {
	aboutDescription2:
		"Ми також пропонуємо широкий вибір свічок, які стануть відмінним доповненням до вашого святкового настрою. Ви можете обрати свічки в різних кольорах, формах та розмірах, щоб створити найкращу емоцію для особливого моменту.",
	aboutDescription:
		"У Valley Arts ми пропонуємо великий вибір унікальних та витончених топерів для тортів, які додадуть вашому святковому десерту неповторного вигляду. Наші топери - це не лише прості аксесуари, вони є втіленням вашої індивідуальності. Ви знайдете у нас топери на будь-який смак та за будь-якою тематикою.",
	aboutFeature2: "Швидкі терміни виконання замовлень",
	aboutFeature3:
		"Швидка відправка, щоб ваші товари потрапили до вас якомога швидше",
	aboutFeature4: "Працюємо з 2015 року ми вже зробили більше 10000 виробів",
	aboutFeature5: "Виконуємо індивідуальні замовлення",
	aboutFeature6: "У нас немає мінімального замовлення",
	aboutFeature: "Стильні топери та свічки для кожного свята",
	aboutFooterDescription:
		"ми готові до співпраці з кондитерськими, магазинами для свят, повітряні кульки та магазинами для кондитерів.",
	aboutFooterTitle:
		"у valley arts ми завжди раді бачити вас і допомогти зробити ваші торти ще яскравішими. зробіть замовлення вже сьогодні та оберіть ідеальний топер та свічки. час створювати красу разом",
	aboutTitle2: "вітаємо в магазині",
	aboutTitle3: "valley arts це український бренд декору для тортів",
	aboutTitle: "про valley arts",
	aboutUs: "про нас",
	accept: "Прийняти",
	addCustomText: "додати індивідуальний текст",
	addToCart: "додати до кошика",
	allProducts: "всі товари",
	bestSellingProducts: "лідери продажів",
	cancel: "скасувати",
	card: "картка",
	cart: "кошик",
	cartDescription: "керуйте вашими товарами",
	cartTotals: "загальна сума кошика",
	callback: "Передзвонити для уточнення",
	category: "категорія",
	checkout: "оформлення",
	checkoutDescription: "оформіть ваші товари",
	checkoutWarnMessage2: "оформлення",
	checkoutWarnMessage3: "або",
	checkoutWarnMessage4: "скасуйте",
	checkoutWarnMessage:
		"у вас є активне замовлення, готове до оформлення. Будь ласка, продовжуйте",
	code: "код",
	collection: "колекцій | колекція | колекції | колекцій",
	color: "кольорів | колір | кольори | кольорів",
	convenientCheckout: "зручне оформлення",
	convenientCheckoutDescription: "швидка обробка замовлення",
	cookiePreferences: "Налаштування Cookie",
	cost: "вартість",
	customText: "індивідуальний текст",
	checkoutOrder: "Оформити замовлення",
	contactDetails: "Ваші контактні дані",
	date: "дата",
	decline: "Відхилити",
	delivery: "доставка",
	deliveryTitle: "Доставка \"Нова пошта\"",
	deliveryAcrossUkraine: "доставка по Україні",
	deliveryAcrossUkraineDescription:
		"відправка \"Новою поштою\" кожного робочого дня",
	deliveryInfoMessage: "за тарифами \"Нова пошта\"",
	discount: "знижка",
	division: "Відділення/поштомат або їх адреса",
	emptyCartMessage: "наразі у вашому кошику немає товарів",
	email: "Електронна пошта",
	emailError: "Введіть вашу електронну адресу",
	faq: "ЧаПи",
	faqQuestion1Description3:
		"Далі просто надайте дані для доставки та здійсніть оплату.",
	faqQuestion1Description:
		"Оберіть потрібний декор, розмір, колір, за бажанням додайте текст (якщо є така можливість), і додайте до кошика. Перейдіть до кошика, перевірте замовлення та натисніть кнопку",
	faqQuestion1Title: "як зробити замовлення?",
	faqQuestion2Description2:
		"Також ви можете приміряти розмір лінійкою до кілець, у яких випікаються бісквіти, або дізнатися у кондитера, який розмір краще підійде. Все залежить від вашого смаку, чи хочете ви великий топер, чи менший.",
	faqQuestion2Description:
		"Скористайтесь зручною табличкою співвідношення стандартних діаметрів торта до топерів різних розмірів від 10 до 15 см.",
	faqQuestion2Title: "як підібрати розмір під торт?",
	faqQuestion3Description2: "від",
	faqQuestion3Description3: "по Києву",
	faqQuestion3Description4: "в інші міста",
	faqQuestion3Description5:
		"вартість залежить від габаритів посилки та оціночної вартості. Ми вказуємо повну вартість для страхування посилки.",
	faqQuestion3Description: "Відправляємо службою доставки «Нова пошта»",
	faqQuestion4Description10:
		"ОБЕРЕЖНО ПРОТИРАЙТЕ ХЛОРГЕКСИДИНОМ (спиртом не протирайте).",
	faqQuestion4Description11: "Будьте обережні з топерами.",
	faqQuestion4Description12: "Дякуємо за розуміння!",
	faqQuestion4Description2:
		"ПРИ ВІДПРАВЦІ НА ПОШТОМАТ, ЗА ПРАВИЛАМИ ПОШТИ, ВИ НЕ ЗМОЖЕТЕ ОТРИМАТИ КОМПЕНСАЦІЮ У РАЗІ ВТРАТИ АБО ПОШКОДЖЕННЯ.",
	faqQuestion4Description3:
		"ПЕРЕВІРЯЙТЕ ВСІ СКЛАДОВІ, КОЛІР ТА РОЗМІР У ДЕНЬ ОТРИМАННЯ!",
	faqQuestion4Description4:
		"ПРИ ПЕРЕВІРЦІ ВДОМА ЧИ В ІНШИЙ ДЕНЬ ВІДПОВІДАЛЬНІСТЬ ЛЕЖИТЬ ВИКЛЮЧНО НА ОТРИМУВАЧІ.",
	faqQuestion4Description5:
		"АКРИЛ - ЦЕ ДУЖЕ НІЖНИЙ, КРИХКИЙ МАТЕРІАЛ! З НИМ ПОТРІБНО БУТИ ДУЖЕ ОБЕРЕЖНИМ.",
	faqQuestion4Description6: "ОБЕРЕЖНО ДІСТАВАЙТЕ З УПАКОВКИ.",
	faqQuestion4Description7: "ОБЕРЕЖНО ЗНІМАЙТЕ ПЛІВКУ.",
	faqQuestion4Description8:
		"Всі топери і декор мають захисну плівку. Плівка може бути біла або прозора. Знімайте на твердій поверхні.",
	faqQuestion4Description9:
		"ОБЕРЕЖНО ВСТАВЛЯЙТЕ В ТОРТ (особливо, якщо це ганаш покриття).",
	faqQuestion4Description:
		"ПОСИЛКУ ОГЛЯДАЙТЕ ПРИ ОТРИМАННІ У ВІДДІЛЕННІ ПОШТИ. ЛИШЕ ТАК МИ ЗМОЖЕМО НАПИСАТИ ПРЕТЕНЗІЮ НА КОМПЕНСАЦІЮ ТА ЗАМІНИТИ ВИРІБ У НАЙБЛИЖЧІ РОБОЧІ ДНІ.",
	faqQuestion4Title: "а якщо топер зламався, що робити?",
	faqTitle: "часті питання",
	filter: "фільтр",
	firstName: "Ім'я",
	firstNameError: "Введіть ваше ім'я",
	forWholesaleCooperation: "для гуртової співпраці",
	free: "безкоштовно",
	goBack: "повернутися",
	home: "головна",
	information: "інформація",
	inputCustomTextPlaceholder: "ваш індивідуальний текст",
	inputCustomTextRegExpError: "використовуйте максимум 4 слова",
	inputCustomTextRequiredError: "введіть ваш індивідуальний текст",
	inputSearchProductsPlaceholder: "пошук товарів...",
	material: "матеріалів | матеріал | матеріали | матеріалів",
	next: "наступна",
	nextPage: "наступна сторінка",
	orderDetails: "деталі замовлення",
	orderNumber: "номер замовлення",
	orderReceiptDescription:
		"дякуємо за довіру. Очікуйте на відправку та номер ТТН",
	orderReceiptTitle: "ваше замовлення отримано!",
	orderNote: "Примітка до замовлення (необовʼязково)",
	lastName: "Прізвище",
	lastNameError: "Введіть ваше прізвище",
	pageNotFoundDetails:
		"Вибачте, але ми не змогли знайти сторінку, яку ви шукали",
	pageNotFoundMessage: "сторінку не знайдено",
	paymentMethod: "метод оплати",
	payment: "Оплата",
	paymentDescription: "Оплатіть ваше замовлення",
	previous: "попередня",
	previousPage: "попередня сторінка",
	product: "товарів | товар | товари | товарів",
	productCategories: "категорії товарів",
	productionTime: "термін виготовлення",
	productionTimeDescription: "до 2-х робочих днів",
	publicOffer: "Договір оферти",
	privacyPolicy: "Політика конфіденційності",
	phoneNumber: "Номер телефону",
	phoneNumberError: "Введіть ваш номер мобільного телефону",
	placeOrder: "Замовлення підтверджую",
	payByCard: "Оплата карткою",
	pay: "Оплатити",
	paymentHint: "Ваше замовлення вже сформованно, але чекає на оплату. Для оплати перейдіть за посиланням натиснувши кнопку \"Оплатити\"",
	paymentHint2: "Зверніть увагу, що платіжне посилання дійсне протягом 24 годин.",
	quantity: "кількість",
	receipt: "квитанція",
	receiptDescription: "перегляньте ваше замовлення",
	recentlyViewed: "нещодавно переглянуті",
	seeAllProducts: "переглянути всі товари",
	settlement: "Населений пункт",
	shop: "магазин",
	shopNow: "перейти",
	showMore: "показати ще",
	size: "розмірів | розмір | розміри | розмірів",
	subtotal: "проміжна сума",
	tag: "тегів | тег | теги | тегів",
	total: "загалом",
	viewCart: "переглянути кошик",
	workingHours: "час роботи",
	workingHoursWeekdays: "Пн - Пт: 9:00 - 20:00",
	workingHoursWeekend: "Сб - Нд: Вихідні дні (відправок немає)",
	cookieAgreement: {
		title: "Згода на використання файлів Cookie",
		description: [
			"Ми використовуємо необхідні файли cookie, щоб наш сайт працював. З вашої згоди ми також можемо використовувати необов’язкові файли cookie для покращення користувацького досвіду та аналізу трафіку на сайті. Натискаючи \"Прийняти\", ви погоджуєтесь на використання файлів cookie на нашому сайті",
			"Ви можете змінити налаштування файлів cookie в будь-який час, натиснувши"
		]
	},
	meta: {
		index: {
			title: "Топери в Торт та Декор для Вечірок - Valley Arts (Київ)",
			ogTitle:
				"Святкуйте з Valley Arts - Топери в Торт та Декор для Вечірок (Київ)",
			description:
				"Відкрийте для себе найкращі топери в торт, свічки та декор для вечірок у Valley Arts. Зробіть свої святкування незабутніми з нашими унікальними виробами ручної роботи.",
			ogDescription:
				"Купуйте унікальні топери в торт, свічки та декор для вечірок, щоб зробити ваші святкування незабутніми."
		},
		shop: {
			title: "Магазин Топерів в Торт та Декору для Вечірок - Valley Arts",
			ogTitle: "Купуйте найкращі Топери в Торт та Декор для Вечірок",
			description:
				"Перегляньте нашу колекцію топерів в торт, свічок та декору для вечірок. Знайдіть все необхідне для вашого наступного святкування у Valley Arts.",
			ogDescription:
				"Досліджуйте широкий асортимент топерів в торт, свічок та декору для вечірок у Valley Arts. Ідеально підходить для днів народжень, весіль та всіх святкувань."
		},
		shopProduct: {
			title: "Купити {productName} - Valley Arts",
			ogTitle: "Отримайте {productName} у Valley Arts"
		},
		faq: {
			title: "Часті питання - Valley Arts",
			ogTitle: "Часті питання - Valley Arts",
			description:
				"Знайдіть відповіді на часті питання про наші топери в торт, свічки та декор для вечірок. Дізнайтеся більше про Valley Arts.",
			ogDescription:
				"Маєте питання? Знайдіть відповіді про наші топери в торт, свічки та декор для вечірок у Valley Arts. Отримайте всю необхідну інформацію тут."
		},
		about: {
			title: "Про нас - Valley Arts",
			ogTitle: "Про Valley Arts",
			description:
				"Дізнайтеся про Valley Arts, магазин топерів в торт, свічок та декору для вечірок. Відкрийте нашу історію та нашу відданість якості.",
			ogDescription:
				"Відкрийте для себе Valley Arts та нашу відданість наданню унікальних топерів в торт, свічок та декору для вечірок. Дізнайтеся про нашу подорож та цінності."
		},
		orderCart: {
			title: "Ваш кошик - Valley Arts",
			ogTitle: "Ваш кошик - Valley Arts",
			description:
				"Перегляньте та оновіть товари у вашому кошику. Купуйте найкращі топери в торт, свічки та декор для вечірок у Valley Arts.",
			ogDescription:
				"Перевірте ваш кошик та зробіть необхідні оновлення. Купуйте унікальні топери в торт, свічки та декор для вечірок у Valley Arts."
		},
		orderCheckout: {
			title: "Оформлення замовлення - Valley Arts",
			ogTitle: "Оформлення замовлення - Valley Arts",
			description:
				"Завершіть покупку топерів в торт, свічок та декору для вечірок. Насолоджуйтесь безпечним оформленням замовлення у Valley Arts.",
			ogDescription:
				"Завершіть покупку топерів в торт, свічок та декору для вечірок. Насолоджуйтесь безпечним та легким процесом оформлення замовлення у Valley Arts."
		},
		orderReceipt: {
			title: "Підтвердження замовлення - Valley Arts",
			ogTitle: "Замовлення підтверджено - Valley Arts",
			description:
				"Ваше замовлення було оформлено! Знайдіть деталі замовлення та відстежуйте ваші топери в торт, свічки та декор для вечірок у Valley Arts.",
			ogDescription:
				"Дякуємо за вашу покупку! Перегляньте деталі вашого замовлення та відстежуйте ваші топери в торт, свічки та декор для вечірок у Valley Arts."
		},
		publicOffer: {
			title: "Публічна оферта - Valley Arts",
			ogTitle: "Публічна оферта - Valley Arts",
			description:
				"Умови публічної оферти та правила користування сервісом Valley Arts.",
			ogDescription:
				"Умови публічної оферти та правила користування сервісом Valley Arts."
		},
		privacyPolicy: {
			title: "Політика конфіденційності - Valley Arts",
			ogTitle: "Політика конфіденційності - Valley Arts",
			description:
				"Інформація про те, як Valley Arts збирає, використовує та захищає персональні дані.",
			ogDescription:
				"Інформація про те, як Valley Arts збирає, використовує та захищає персональні дані."
		}
	}
};
